export default {
      id: "email-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#email",
      toString: function () {
        return this.url;
      }
    }